<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Instansi</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'adminInstanceCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'adminInstance' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Instansi
                </h4>
            </div>
        </div>
    </div>

    <div>
        <form @submit.prevent="submitForm()">
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.name.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataInstance.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataInstance.name.required">Nama wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.type.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Tipe Instansi</label>
                        <!-- <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataInstance.type.$model"
                        :disabled="loading"> -->
                        <select name="" id="" v-model="dataInstance.type" class="form-control">
                            <option :value="item.id" v-for="item in instanceType" :key="item.name">{{item.name}}</option>
                        </select>
                        <div class="error" v-if="!$v.dataInstance.type.required">Tipe instansi wajib diisi</div>
                    </div>
                    
                    <div class="form-group">
                        <label for="select-2-form" class="col-form-label text-left d-block">Organization</label>
                        <select name="" id="" v-model="dataInstance.organization_id" class="form-control">
                            <option :value="''">-- Pilih Organization --</option>
                            <option :value="item.id" v-for="item in listOrganization" :key="item.id">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.company_code_access.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Kode Akses Perusahaan</label>
                        <input type="text" class="form-control" placeholder="Masukkan Kode Akses Perusahaan" 
                        v-model.trim="$v.dataInstance.company_code_access.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataInstance.company_code_access.required">Kode Akses Perusahaan wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.company_code.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Kode Perusahaan</label>
                        <input type="text" class="form-control" placeholder="Masukkan Kode Perusahaan" 
                        v-model.trim="$v.dataInstance.company_code.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataInstance.company_code.required">Kode Perusahaan wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.address.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Alamat Perusahaan</label>
                        <input type="text" class="form-control" placeholder="Masukkan Alamat Perusahaan" 
                        v-model.trim="$v.dataInstance.address.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataInstance.address.required">Alamat Perusahaan wajib diisi</div>
                    </div>

                    <!-- <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.logo.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Logo</label>
                        <input type="file" id="upload-logo" :disabled="loading" @change="logoUpload">
                        <div class="error" v-if="!$v.dataInstance.logo.required">Logo wajib diisi</div>
                    </div> -->

                    <div class="row align-items-center mb-3" v-if="$route.name == 'adminInstanceCreate'">
                        <div class="col-12 col-md-4 col-lg-2">
                            <img :src="logoImage == null ? require('@/assets/custom-images/placeholder-image.png') : logoImage" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 col-md-8 col-lg-10">
                            <label class="form-label">Logo</label>
                            <div class="form-group custom-file" :class="{ 'is-invalid': $v.dataInstance.logo.$error }">
                                <label for="select-2-form" class="col-form-label text-left d-block">Logo</label>
                                <input type="file" class="custom-file-input mb-3" id="upload-logo" :disabled="loading" @change="logoUpload" style="display: none" accept="image/png, image/jpg, image/jpeg">
                                <label class="custom-file-label" for="upload-logo">{{labelLogo}}</label>
                                <div class="error mt-2" style="margin-bottom: 15px" v-if="!$v.dataInstance.logo.required">Logo wajib diisi</div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3" v-else>
                        <div class="col-12 col-md-4 col-lg-2">
                            <img :src="logoImage == null ? require('@/assets/custom-images/placeholder-image.png') : logoImage" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 col-md-8 col-lg-10">
                            <label class="form-label">Logo</label>
                            <div class="form-group custom-file">
                                <label for="select-2-form" class="col-form-label text-left d-block">Logo</label>
                                <input type="file" class="custom-file-input mb-3" id="upload-logo" :disabled="loading" @change="logoUpload" style="display: none" accept="image/png, image/jpg, image/jpeg">
                                <label class="custom-file-label" for="upload-logo">{{labelLogo}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mb-3">
                        <div class="col-12 col-md-4 col-lg-2">
                            <img :src="logoImagePrint == null ? require('@/assets/custom-images/placeholder-image.png') : logoImagePrint" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 col-md-8 col-lg-10">
                            <label class="form-label">Logo Print</label>
                            <div class="form-group custom-file">
                                <label for="select-2-form" class="col-form-label text-left d-block">Logo Print</label>
                                <input type="file" class="custom-file-input mb-3" id="upload-logo-print" :disabled="loading" @change="logoUploadPrint" style="display: none" accept="image/png, image/jpg, image/jpeg">
                                <label class="custom-file-label" for="upload-logo-print">{{labelLogoPrint}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.cron.$error }">
                        <label for="">Waktu Cron Job</label>
                        <vue-timepicker style="width: 100%" v-model.trim="$v.dataInstance.cron.$model"></vue-timepicker>
                            <div class="error" v-if="!$v.dataInstance.cron.required">Waktu Cron Job wajib diisi</div>
                    </div>

                    <div class="form-check form-group">
                        <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                            <input type="checkbox" class="custom-control-input" id="customSwitchPrimary3" v-model="dataInstance.is_has_unit">
                            <label class="custom-control-label" for="customSwitchPrimary3">Memiliki Unit</label>
                        </div>
                    </div>

                    <div class="form-check form-group">
                        <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                            <input type="checkbox" class="custom-control-input" id="customSwitchPrimary" v-model="dataInstance.is_sim">
                            <label class="custom-control-label" for="customSwitchPrimary">Memiliki SIM</label>
                        </div>
                    </div>

                    <div class="form-check form-group">
                        <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                            <input type="checkbox" class="custom-control-input" id="stsSwitch" v-model="dataInstance.is_use_sts">
                            <label class="custom-control-label" for="stsSwitch">Memiliki Laporan STS</label>
                        </div>
                    </div>

                    <div class="form-check form-group">
                        <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                            <input type="checkbox" class="custom-control-input" id="customSwitchPrimary2" v-model="dataInstance.is_use_approval">
                            <label class="custom-control-label" for="customSwitchPrimary2">Memiliki Admin Releaser</label>
                        </div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.registration_print_template.$error }" v-if="dataInstance.type ? instanceType.find(item => item.id == dataInstance.type).code == 'HEALTH_CARE' : false">
                        <label>Pilih Template Registrasi</label>
                        <select class="js-example-basic-multiple js-states form-control select-template-registration" id="id_label_multiple_registration" :disabled="loading"
                            v-model="dataInstance.registration_print_template">
                            <option value="1">Template 1</option>
                            <option value="2">Template 2</option>
                        </select>
                        <div class="error" v-if="!$v.dataInstance.registration_print_template.required">Template registrasi wajib diisi</div>
                    </div>
                    
                    <div class="form-group">
                        <label>Pilih Metode Pembayaran Yang Bisa Digunakan</label>
                        <select class="js-example-basic-multiple js-states form-control select-payment-method" id="id_label_multiple" multiple="multiple" :disabled="loading" v-select2
                            v-model="dataInstance.payment_methods">
                            <option value="QRIS">QRIS Dinamis</option>
                            <option value="QRIS_STATIC">QRIS Statis</option>
                            <option value="BPD">Virtual Account BPD Bali</option>
                            <option value="TUNAI">Tunai</option>
                        </select>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="select-2-form" class="col-form-label text-left d-block">QRIS Merchant Pan</label>
                                <input type="text" class="form-control" placeholder="Masukkan QRIS Merchant Pan" 
                                v-model.trim="dataInstance.qris_merchant_pan"
                                :disabled="loading">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="select-2-form" class="col-form-label text-left d-block">QRIS Terminal User</label>
                                <input type="text" class="form-control" placeholder="Masukkan Terminal User" 
                                v-model.trim="dataInstance.qris_terminal_user"
                                :disabled="loading">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="select-2-form" class="col-form-label text-left d-block">QRIS Product Code</label>
                                <input type="text" class="form-control" placeholder="Masukkan Product Code" 
                                v-model.trim="dataInstance.qris_product_code"
                                :disabled="loading">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="select-2-form" class="col-form-label text-left d-block">QRIS The Key</label>
                                <input type="text" class="form-control" placeholder="Masukkan Terminal User" 
                                v-model.trim="dataInstance.qris_the_key"
                                :disabled="loading">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nama Bank</label>
                                <input type="text" class="form-control" v-model="dataInstance.bank_name" :disabled="loading" required>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nama Cabang Bank</label>
                                <input type="text" class="form-control" v-model="dataInstance.bank_branch_name" :disabled="loading" required>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nomor Rekening Bank</label>
                                <input type="text" class="form-control" v-model="dataInstance.bank_account_number" :disabled="loading" required>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.va_prefix.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">VA Prefix</label>
                        <input type="text" class="form-control" placeholder="Masukkan VA Prefix" 
                        v-model.trim="dataInstance.va_prefix"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataInstance.va_prefix.required">ID Terakhir Perusahaan wajib diisi</div>
                    </div>

                    <div v-if="$route.name == 'adminInstanceCreate'">
                        <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.last_id.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">ID Terakhir</label>
                            <input type="text" class="form-control" placeholder="Masukkan ID Terakhir" 
                            v-model.trim="$v.dataInstance.last_id.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataInstance.last_id.required">ID Terakhir Perusahaan wajib diisi</div>
                        </div>

                        <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.username.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Username</label>
                            <input type="text" class="form-control" placeholder="Masukkan Username" 
                            v-model.trim="$v.dataInstance.username.$model"
                            autocomplete="off"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataInstance.username.required">Username wajib diisi</div>
                            <div class="error" v-if="!$v.dataInstance.username.username">Username tidak boleh berisi spasi atau simbol</div>
                        </div>

                        <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.password.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Kata Sandi" 
                            v-model.trim="$v.dataInstance.password.$model"
                            autocomplete="off"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataInstance.password.required">Kata Sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataInstance.password.minLength">Kata Sandi minimal 8 karakter </div>
                            <div class="error" v-if="!$v.dataInstance.password.password">Konfirmasi kata Sandi harus terdiri dari minimal 8 karakter huruf besar, huruf kecil, angka dan symbol. karakter </div>
                        </div>

                        <div class="form-group" :class="{ 'is-invalid': $v.dataInstance.password_confirmation.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Konfirmasi Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Konfirmasi Kata Sandi" 
                            v-model.trim="$v.dataInstance.password_confirmation.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataInstance.password_confirmation.required">Konfirmasi kata sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataInstance.password_confirmation.sameAs">Konfirmasi kata sandi harus sama dengan form diatas</div>
                        </div>
                    </div>

                    <div v-else>
                        <div class="form-check form-group mt-2" v-if="this.$route.name == 'adminInstanceEdit'">
                            <input class="form-check-input" type="checkbox" v-model="dataInstance.is_active" id="defaultCheck1">
                            <label class="form-check-label" for="defaultCheck1" style="margin-top: 1px;">
                                Apakah Instansi Aktif ?
                            </label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Pilih Tipe Transaksi</label>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="dataInstance.transaction" id="lg">
                            <label class="form-check-label" for="lg" style="margin-top: 1px;">
                                Transaksi Langsung
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="dataInstance.billing" id="lt">
                            <label class="form-check-label" for="lt" style="margin-top: 1px;">
                                Transaksi Tetap
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Pengguna
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<style>
    .vue__time-picker input.display-time{
        width: 100%;
    }
    .vue__time-picker .controls{
        display: none;
    }
</style>

<script>
    import Swal from 'sweetalert2'
    import { required, requiredIf, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
    const username = helpers.regex('username', /^[a-z0-9_]*$/)
    const passwordRegex = helpers.regex('password', /^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[A-Z]).{8,20}$/)

    export default {
        data() {
            return {
                labelLogo: 'Pilih File ...',
                labelLogoPrint: 'Pilih File ...',
                loading: false,
                logoImage: null,
                logoImagePrint: null,
                instanceType: [],
                listOrganization: [],
                dataInstance: {
                    name: '',
                    type: '',
                    payment_methods: [],
                    registration_print_template: '',
                    name: '',
                    organization_id: '',
                    company_code_access: '',
                    company_code: '',
                    bank_name: '',
                    bank_branch_name: '',
                    bank_account_number: '',
                    cron: '00:00',
                    last_id: '',
                    address: '',
                    logo: null,
                    logoPrint: null,
                    username: '',
                    password: '',
                    password_confirmation: '',
                    qris_merchant_pan: '',
                    qris_terminal_user: '',
                    qris_product_code: '',
                    qris_the_key: '',
                    va_prefix: '',
                    is_has_unit: 0,
                    is_sim: 0,
                    is_use_sts: 0,
                    is_use_approval: 0,
                    is_active: 0,
                    transaction: false,
                    billing: false,
                },
            };
        },
        validations() {
            const self = this
            if(this.$route.name == 'adminInstanceCreate'){
                return {
                    dataInstance: {
                        name: {
                            required
                        },
                        type: {
                            required
                        },
                        company_code_access: {
                            required
                        },
                        registration_print_template: function(){
                            const check = self.dataInstance.type ? self.instanceType.find(item => item.id == self.dataInstance.type).code == 'HEALTH_CARE' : false
                            if(check){
                                return { required }
                            }else{
                                return { }
                            }
                        }(),
                        company_code: {
                            required
                        },
                        address: {
                            required
                        },
                        cron: {
                            required
                        },
                        last_id: {
                            required
                        },
                        logo: {
                            required
                        },
                        username: {
                            required,
                            username
                        },
                        va_prefix: {
                            required
                        },
                        password: {
                            passwordRegex,
                            required,
                            minLength: minLength(8)
                        },
                        password_confirmation: {
                            required,
                            sameAsPassword: sameAs('password'),
                            minLength: minLength(8)
                        }
                    }
                }
            }else{
                return {
                    dataInstance: {
                        name: {
                            required
                        },
                        type: {
                            required
                        },
                        registration_print_template: function(){
                            const check = self.dataInstance.type ? self.instanceType.find(item => item.id == self.dataInstance.type).code == 'HEALTH_CARE' : false
                            if(check){
                                return { required }
                            }else{
                                return { }
                            }
                        }(),
                        cron: {
                            required
                        },
                        // last_id: {
                        //     required
                        // },
                        company_code_access: {
                            required
                        },
                        company_code: {
                            required
                        },
                        address: {
                            required
                        },
                        va_prefix: {
                            required
                        },
                        // username: {
                        //     required,
                        //     username
                        // },
                    }
                }
            }
        },
        components: { VueTimepicker },
        methods: {
            // billingChecked() {
            //     if(this.dataInstance.billing){
            //         this.dataInstance.transaction = true
            //     }
            // },
            transactionChecked() {
                console.log(this.dataInstance.billing);
                if(this.dataInstance.billing){
                    this.dataInstance.transaction = true
                }
            },
            logoUpload(e) {
                const file = e.target.files[0]

                if(this.validationImage(file)){ 
                    document.getElementById('upload-logo').value = ""
                    this.labelLogo = 'Pilih File ...'
                    return
                }

                this.logoImage = URL.createObjectURL(file);
                this.dataInstance.logo = file
                this.labelLogo = file.name
            },
            logoUploadPrint(e) {
                const file = e.target.files[0]

                if(this.validationImage(file)){ 
                    document.getElementById('upload-logo-print').value = ""
                    this.labelLogo = 'Pilih File ...'
                    return
                }

                console.log(file);

                this.logoImagePrint = URL.createObjectURL(file);
                this.dataInstance.logoPrint = file
                console.log(file);
                this.labelLogoPrint = file.name
            },
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataInstance.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                let dataStored = new FormData()

                if(this.$route.name == 'adminInstanceCreate') {
                    url = `company/store`
                    method = 'POST'

                    dataStored.append('name', this.dataInstance.name)
                    dataStored.append('company_type_id', this.dataInstance.type)
                    dataStored.append('organization_id', this.dataInstance.organization_id)
                    dataStored.append('company_code_access', this.dataInstance.company_code_access)
                    dataStored.append('company_code', this.dataInstance.company_code)
                    dataStored.append('address', this.dataInstance.address)
                    dataStored.append('logo', this.dataInstance.logo)
                    dataStored.append('logo_print', this.dataInstance.logoPrint)
                    dataStored.append('username', this.dataInstance.username)
                    dataStored.append('password', this.dataInstance.password)
                    dataStored.append('cron_time', this.dataInstance.cron)
                    dataStored.append('last_id', this.dataInstance.last_id)

                    dataStored.append('bank_name', this.dataInstance.bank_name)
                    dataStored.append('bank_branch_name', this.dataInstance.bank_branch_name)
                    dataStored.append('bank_account_number', this.dataInstance.bank_account_number)

                    dataStored.append('qris_merchant_pan', this.dataInstance.qris_merchant_pan)
                    dataStored.append('qris_terminal_user', this.dataInstance.qris_terminal_user)
                    dataStored.append('qris_product_code', this.dataInstance.qris_product_code)
                    dataStored.append('qris_the_key', this.dataInstance.qris_the_key)
                    dataStored.append('va_prefix', this.dataInstance.va_prefix)

                    dataStored.append('registration_print_template', this.dataInstance.registration_print_template)
                    this.dataInstance.payment_methods.forEach(element => {
                        dataStored.append('payment_methods[]', element)
                    });

                    dataStored.append('is_has_unit', this.dataInstance.is_has_unit ? 1 : 0)
                    dataStored.append('is_use_sts', this.dataInstance.is_use_sts ? 1 : 0)
                    dataStored.append('is_sim', this.dataInstance.is_sim ? 1 : 0)
                    dataStored.append('is_use_approval', this.dataInstance.is_use_approval ? 1 : 0)
                    dataStored.append('is_transaction', this.dataInstance.transaction ? 1 : 0)
                    dataStored.append('is_billing', this.dataInstance.billing ? 1 : 0)
                    dataStored.append('password_confirmation', this.dataInstance.password_confirmation)

                    alertSuccess = 'Berhasil membuat instansi baru!'
                }else{
                    url = `company/update/${this.$route.params.id}`
                    method = 'POST',
                    alertSuccess = 'Berhasil mengupdate instansi!'

                    dataStored.append('name', this.dataInstance.name)
                    dataStored.append('company_type_id', this.dataInstance.type)
                    dataStored.append('organization_id', this.dataInstance.organization_id)
                    dataStored.append('company_code_access', this.dataInstance.company_code_access)
                    dataStored.append('company_code', this.dataInstance.company_code)
                    dataStored.append('address', this.dataInstance.address)
                    dataStored.append('cron_time', this.dataInstance.cron)
                    dataStored.append('last_id', this.dataInstance.last_id)

                    dataStored.append('bank_name', this.dataInstance.bank_name)
                    dataStored.append('bank_branch_name', this.dataInstance.bank_branch_name)
                    dataStored.append('bank_account_number', this.dataInstance.bank_account_number)

                    dataStored.append('qris_merchant_pan', this.dataInstance.qris_merchant_pan)
                    dataStored.append('qris_terminal_user', this.dataInstance.qris_terminal_user)
                    dataStored.append('qris_product_code', this.dataInstance.qris_product_code)
                    dataStored.append('qris_the_key', this.dataInstance.qris_the_key)
                    dataStored.append('va_prefix', this.dataInstance.va_prefix)

                    dataStored.append('registration_print_template', this.dataInstance.registration_print_template)
                    this.dataInstance.payment_methods.forEach(element => {
                        dataStored.append('payment_methods[]', element)
                    });

                    dataStored.append('is_has_unit', this.dataInstance.is_has_unit ? 1 : 0)
                    dataStored.append('is_use_sts', this.dataInstance.is_use_sts ? 1 : 0)
                    dataStored.append('is_sim', this.dataInstance.is_sim ? 1 : 0)
                    dataStored.append('is_use_approval', this.dataInstance.is_use_approval ? 1 : 0)
                    dataStored.append('is_transaction', this.dataInstance.transaction ? 1 : 0)
                    dataStored.append('is_billing', this.dataInstance.billing ? 1 : 0)
                    if(this.dataInstance.logo){
                        dataStored.append('logo', this.dataInstance.logo)
                    }
                    if(this.dataInstance.logoPrint){
                        dataStored.append('logo_print', this.dataInstance.logoPrint)
                    }
                    dataStored.append('is_active', this.dataInstance.is_active)
                    // dataStored.append('_method', 'PUT')
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: dataStored,
                    headers: { 
                        'Authorization': `Bearer ${this.$cookies.get("token_admin")}`,
                        'content-type': `multipart/form-data`
                    }
                })
                .then(response => {
                    const result = response.data;
                    if(result.success) {
                        this.sAlert('success', "Berhasil membuat template form baru!")
                        this.$router.push({ name: 'adminInstance' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        async mounted() {
            this.loadingInitial = true

            const instanceType = await this.$http.get(`${this.API_URL}administrator/company-type`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
            })
            this.instanceType = instanceType.data.data
            this.dataInstance.type = this.instanceType[0].id

            // LOAD DATA IF ROUTE IS EDIT
            try {
                const organization = await this.$http.get(`${this.API_URL}administrator/organization`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                this.listOrganization = organization.data.data
            } catch (error) {
                console.log(error);
            }

            if(this.$route.name == 'adminInstanceEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}company/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_admin")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.dataInstance.name = result.data.name
                        this.dataInstance.type = result.data.company_type_id
                        this.dataInstance.organization_id = result.data.organization_id
                        this.dataInstance.address = result.data.address
                        this.dataInstance.company_code_access = result.data.company_code_access
                        this.dataInstance.company_code = result.data.company_code
                        this.dataInstance.is_active = result.data.is_active
                        this.dataInstance.cron = result.data.cron_time
                        this.dataInstance.is_sim = result.data.is_sim
                        this.dataInstance.is_has_unit = result.data.is_has_unit

                        this.dataInstance.bank_name = result.data.bank_name
                        this.dataInstance.bank_branch_name = result.data.bank_branch_name
                        this.dataInstance.bank_account_number = result.data.bank_account_number

                        this.dataInstance.qris_merchant_pan = result.data.qris_merchant_pan
                        this.dataInstance.qris_terminal_user = result.data.qris_terminal_user
                        this.dataInstance.qris_product_code = result.data.qris_product_code
                        this.dataInstance.qris_the_key = result.data.qris_the_key
                        this.dataInstance.va_prefix = result.data.va_prefix

                        // const removeArrayString = result.data.payment_methods ? result.data.payment_methods.replace(/'/g, '"') : [];
                        this.dataInstance.registration_print_template = result.data.registration_print_template
                        this.dataInstance.payment_methods = result.data.payment_methods ? result.data.payment_methods : []
                        
                        this.dataInstance.is_use_sts = result.data.is_use_sts
                        this.dataInstance.is_use_approval = result.data.is_use_approval
                        this.dataInstance.username = result.data.username
                        this.dataInstance.last_time = result.data.last_time ? result.data.last_time : ''
                        this.dataInstance.transaction = result.data.is_transaction
                        this.dataInstance.billing = result.data.is_billing
                        this.logoImage = result.data.logo
                        this.logoImagePrint = result.data.logo_print

                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;

                    setTimeout(() => {
                        $('.select-payment-method').select2();
                        // $('.select-template-registration').select2();
                    }, 100);
                })
                .catch(error => {
                    console.log(error);
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }else{
                setTimeout(() => {
                    $('.select-payment-method').select2();
                }, 100);
            }
        }
    }
</script>